import { useSettingsContext } from '@/components/Settings/hooks/useSettingsContext';
import { Box, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FC, ReactNode } from 'react';

export type ErrorLayoutProps = {
  errorTitle?: string;
  errorDetailComponent: ReactNode;
  imageSrc?: string;
  redirectComponent?: ReactNode;
};

const ErrorLayout: FC<ErrorLayoutProps> = ({
  errorDetailComponent,
  errorTitle = "Error",
  imageSrc,
  redirectComponent,
}) => { 
  const Settings = useSettingsContext();
  const theme = useTheme();

  return <Stack 
    direction="row"
    height={"90vh"} 
  >
    <Box
      sx={{
        ...(Settings.errors?.displayImages && {
          [theme.breakpoints.up("md") ]: {
            width: "40vw",
            backgroundImage: `url(${imageSrc})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center"
          }
        })
      }}
    />
    <Box 
      sx={{ 
        [theme.breakpoints.down("md")]: {
          paddingLeft: "7vw",
          paddingRight: "7vw",
          // ...((Settings.errors?.displayImages === false) && {padding: "7vw"}),
          boxSizing: "border-box"
        },
        [theme.breakpoints.up("md")]: {
          paddingLeft: "5vw",
          paddingRight: "5vw",
          width: "60vw"
          // ...((Settings.errors?.displayImages === false) && {padding: "5vw"}),
        },
        height: "100%", 
        display: "flex", 
        flexDirection: "column", 
        justifyContent: "center",
        backgroundColor: "white"
      }}
    >
      <Typography variant="h4" pb={3}>
        {errorTitle}
      </Typography>
      {errorDetailComponent}
      {!!redirectComponent && <Stack
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{marginTop: 3}}
        spacing={2}
      >
        {redirectComponent}

        </Stack>}
    </Box>
  </Stack>
}

export default ErrorLayout;
